var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"topnav-links-container"},_vm._l((_vm.limitedLinks),function(link){return _c('li',{key:link.text},[_c('a',{attrs:{"href":link.url},domProps:{"innerHTML":_vm._s(link.text)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }